import { router } from '@/router'
import store from '@/store'
import nprogress from 'nprogress'
import 'nprogress/nprogress.css'
import { getToken } from '@/utils/auth'
import storage from '@/utils/storage'
import * as tools from '@/utils/tools'
import Cookies from 'js-cookie'
import { removeToken } from '../utils/auth'

const hasPermission = (rounter, toPath) => {
  for (var i = 0; i < rounter.length; i++) {
    for (var j = 0; j < rounter[i].nodes.length; j++) {
      if (toPath.indexOf(rounter[i].nodes[j].path)) {
        return true;
      }
    }
  }
  return false;
}

const whiteList = ['/login', '/dropAccount']

router.beforeEach(async (to, from, next) => {
  console.log('------route-debug------')
  console.log('from: [' + from.path + '] --> to: [' + to.path + ']')
  nprogress.start()
  if (store.getters.lockState === 'lock' && to.name !== 'lock') {
    next({
      replace: true,
      name: 'lock'
    })
  } else if (store.getters.lockState === 'unlock' && to.name === 'lock') {
    next(false)
  } else if (getToken()) {
    // 如果登录过后访问登录页面则跳回主页
    if (to.path === '/login') {
      next({ path: '/' })
      nprogress.done()
    } else {
      // var menus =
      var myMenus = storage.get("srs_menus");
      if (store.getters.addRouters.length === 0 && myMenus.length > 0) {
        store.dispatch('generateRoutes', myMenus)
        router.addRoutes(store.getters.addRouters)
        next({ ...to, replace: true })
      } else {
        if (hasPermission(myMenus, to.path)) {
          next()
        } else {
          // 解决 菜单目录丢失，重新登录获取目录
          // 解决 从 [/] 到 [/401]的套娃问题
          if ((!myMenus || myMenus.length === 0) || (from === '/' && to === '/401')) {
            removeToken()
            next({
              path: '/login'
            })
          } else {
            next({ path: '/401', replace: true, query: { noGoBack: true } })
          }
        }
      }
    }
  } else {
    if (whiteList.indexOf(to.path) !== -1) {
      next()
    } else {
      next('/login')
      nprogress.done() // 如果当前页是 login 则路由不会触发 after 钩子函数，需要手动处理
    }
  }
})

router.afterEach(() => {
  nprogress.done()
})
